import { View } from "@react-pdf/renderer";
import { tableStyles } from "./SmartTitanProjektPDF";
import { DataTableFHWAHeader } from "./DataTableFHWAHeader";
import { DataTableFHWAFooter } from "./DataTableFHWAFooter";
import { DataTableFHWADataRow } from "./DataTableFHWADataRow";

export function DataTableFHWA({ data, tableInput, tableCalculated }) {
  return (
    <View style={tableStyles.tableContainer}>
      {/* TableHeader */}

      <DataTableFHWAHeader isMetric={data.measurementType == 0} />

      {tableInput.map((row, index) => {
        return (
          <DataTableFHWADataRow
            data={data}
            key={index}
            index={index}
            tableInput={tableInput}
            tableCalculated={tableCalculated}
          />
        );
      })}

      {/* Table footer */}
      <DataTableFHWAFooter data={data} />
    </View>
  );
}
